import { NotificationAPI } from '../api/notfication';
import {
  EventBus,
  NOTIFICATION_USER_FUNDS_ADDED, NOTIFICATION_USER_FUNDS_CLEAR_PROCESSING_PAYMENT,
} from '../event-bus';

export const animationType = {
  CAKE: 0,
  CROWN: 1,
  NORMAL: 2,
};

export const NotificationMixin = {
  mixins: [NotificationAPI],
  data() {
    return {
      ANIMATION_TYPES: Object.freeze(animationType),
    };
  },
  methods: {
    async removeNotification(notification) {
      console.log('remove notification');
      const tokens = notification.split('#');
      const timestamp = tokens[tokens.length - 1];
      const res = await this.removeNotificationAPI(timestamp);

      if (res.status === 0) {
        await this.$store.dispatch('notifications/removeNotification', notification);
      }
    },
    getTextUserReward(msg) {
      let html;
      switch (msg) {
        case 'UserRewardRegister':
          html = "You've received a cake for registering! Click here to smash it and see what you've won!";
          break;
        case 'UserRewardWinningEvent':
          html = "You've earned a Mega Cake for winning an event! Win instantly by clicking here to smash it now!";
          break;
        case 'UserRewardCreateTournament':
          html = "You've earned a Mega Cake for creating a tournament! Click here to smash it and see what you've won!";
          break;
        case 'UserRewardCreateAccount':
          html = "You've earned a Mega Cake for creating an account! Win instantly by clicking here to smash it now!";
          break;
        case 'UserRewardConnectAccount':
          html = "You've earned a Mega Cake for connecting a streaming platform to your account! Win instantly by clicking here to smash it now!";
          break;
        case 'UserRewardVerifyGameAccount':
          html = "You've earned a Mega Cake for verifying a game account! Win instantly by clicking here to smash it now!";
          break;
        case 'UserRewardLikeTopPlays':
          html = "You've earned a Mega Cake for like top plays! Win instantly by clicking here to smash it now!";
          break;
        case 'UserRewardTeamRegisteredForBracket':
          html = "You've earned a Mega Cake for registered bracket! Win instantly by clicking here to smash it now!";
          break;
        case 'UserRewardRankTop1':
          html = "You've earned a Mega Cake for finishing top 1 in the tournament! Win instantly by clicking here to smash it now!";
          break;
        case 'UserRewardRankTop3':
          html = "You've earned a Mega Cake for finishing top 3 in the tournament! Win instantly by clicking here to smash it now!";
          break;
        case 'UserRewardWatched15Min':
          html = "You've earned a Mega Cake for watching 15 minutes of the Code Red tournament! Win instantly by clicking here to smash it now!";
          break;
        case 'UserRewardWatched30Min':
          html = "You've earned a Mega Cake for watching 30 minutes of the Code Red tournament! Win instantly by clicking here to smash it now!";
          break;
        case 'UserRewardWatched60Min':
          html = "You've earned a Mega Cake for for watching 1 hour of the Code Red tournament! Win instantly by clicking here to smash it now!";
          break;
        case 'UserRewardWatched120Min':
          html = "You've earned a Mega Cake for watching 2 hours of the Code Red tournament! Win instantly by clicking here to smash it now!";
          break;
        case 'UserRewardWatched60MinAfterFirst120Min':
          html = "You've earned a Mega Cake for watching an additional hour of the Code Red tournament! Win instantly by clicking here to smash it now!";
          break;
        default:
          html = "You've earned a Mega Cake! Click here to smash it and see what you've won!";
          break;
      }
      return html;
    },
    getTextCrownNotificationOnBoard(msg) {
      let html;
      switch (msg) {
        case 'UserRewardRegister':
          html = "You've received __COUNT__ for joining the event __NAME__!";
          break;
        case 'UserRewardDailyLogin':
          html = "You've received __COUNT__ for daily login!";
          break;
        case 'UserRewardWinningEvent':
          html = "You've earned __COUNT__ for winning event __NAME__!";
          break;
        case 'UserRewardCreateTournament':
          html = "You've earned __COUNT__ for creating a tournament!";
          break;
        case 'UserRewardCreateAccount':
          html = "You've earned __COUNT__ for creating an account!";
          break;
        case 'UserRewardConnectAccount':
          html = "You've earned __COUNT__ for connecting a streaming platform!";
          break;
        case 'UserRewardVerifyGameAccount':
          html = "You've earned __COUNT__ for verifying a game account!";
          break;
        case 'UserRewardLikeTopPlays':
          html = "You've earned __COUNT__ for like top plays!";
          break;
        case 'UserRewardTeamRegisteredForBracket':
          html = "You've earned __COUNT__ for registered bracket!";
          break;
        case 'UserRewardTeamCompletesBracket':
          html = "You've received __COUNT__ for completing bracket!";
          break;
        case 'UserRewardRankTop1':
          html = "You've received __COUNT__ for finishing 1st in __NAME__!";
          break;
        case 'UserRewardRankTop3':
          html = "You've received __COUNT__ for finishing top 3 in __NAME__!";
          break;
        case 'UserRewardRunTournament':
          html = "You've received __COUNT__ for running an event!";
          break;
        case 'UserRewardQuestComplete':
          html = "You've received __COUNT__ for completing __NAME__!";
          break;
        case 'UserRewardWatched15Min':
          html = "You've received __COUNT__ for watching 15 minutes of the Code Red tournament!";
          break;
        case 'GuestFeatureWatched15Min':
          html = "You've received __COUNT__ for watching 15 minutes of the Code Red tournament! <br><br>Click here to redeem your rewards and create an account!";
          break;
        case 'UserRewardWatched30Min':
          html = "You've received __COUNT__ for watching 30 minutes of the Code Red tournament!";
          break;
        case 'GuestFeatureWatched30Min':
          html = "You've received __COUNT__ for watching 30 minutes of the Code Red tournament! <br><br>Click here to redeem your rewards and create an account!";
          break;
        case 'UserRewardWatched60Min':
          html = "You've received __COUNT__ for watching 1 hour of the Code Red tournament!";
          break;
        case 'GuestFeatureWatched60Min':
          html = "You've received __COUNT__ for watching 1 hour of the Code Red tournament! <br><br>Click here to redeem your rewards and create an account!";
          break;
        case 'UserRewardWatched120Min':
          html = "You've received __COUNT__ for watching 2 hours of the Code Red tournament!";
          break;
        case 'GuestFeatureWatched120Min':
          html = "You've received __COUNT__ for watching 2 hours of the Code Red tournament! <br><br>Click here to redeem your rewards and create an account!";
          break;
        case 'UserRewardWatched60MinAfterFirst120Min':
          html = "You've received __COUNT__ for watching an additional hour of the Code Red tournament!";
          break;
        case 'GuestFeatureWatched60MinAfterFirst120Min':
          html = "You've received __COUNT__ for watching an additional hour of the Code Red tournament! <br><br>Click here to redeem your rewards and create an account!";
          break;
        default:
          html = "You've earned __COUNT__!";
          break;
      }
      return html;
    },
    getTextUserRewardForQuest(msgNotification, typeAward, amount, eventTitle) {
      let html;
      if (typeAward === 0) {
        html = "You've earned a Mega Cake! Click here to smash it and see what you've won!";
      } else if (typeAward === 1) {
        html = this.getTextCrownNotificationOnBoard(msgNotification);
        html = html.replace('__NAME__', eventTitle);
        html = html.replace('__COUNT__', amount + ' crowns');
      }
      return html;
    },
    getTextMsgForGuest(msg) {
      let html;
      switch (msg) {
        case 'GuestFeatureWatched15Min':
          html = "You've earned a Mega Cake for watching 15 minutes of the Code Red tournament! <br><br>Click here to redeem your rewards and create an account!";
          break;
        case 'GuestFeatureWatched30Min':
          html = "You've earned a Mega Cake for watching 30 minutes of the Code Red tournament! <br><br>Click here to redeem your rewards and create an account!";
          break;
        case 'GuestFeatureWatched60Min':
          html = "You've earned a Mega Cake for for watching 1 hour of the Code Red tournament! <br><br>Click here to redeem your rewards and create an account!";
          break;
        case 'GuestFeatureWatched120Min':
          html = "You've earned a Mega Cake for watching 2 hours of the Code Red tournament!<br><br>Click here to redeem your rewards and create an account!";
          break;
        case 'GuestFeatureWatched60MinAfterFirst120Min':
          html = "You've earned a Mega Cake for watching an additional hour of the Code Red tournament!<br><br>Click here to redeem your rewards and create an account!";
          break;
        default:
          html = "You've earned a Mega Cake!";
          break;
      }
      return html;
    },
    getAnimationTextUserReward(msgNotification) {
      let html;
      switch (msgNotification) {
        case 'UserRewardRegister':
          html = "You've received __COUNT__ for joining the event __NAME__!";
          break;
        case 'UserRewardDailyLogin':
          html = "You've received __COUNT__ for daily login!";
          break;
        case 'UserRewardWinningEvent':
          html = "You've earned __COUNT__ for winning event __NAME__!";
          break;
        case 'UserRewardCreateTournament':
          html = "You've earned __COUNT__ for creating a tournament!";
          break;
        case 'UserRewardCreateAccount':
          html = "You've earned __COUNT__ for creating an account!";
          break;
        case 'UserRewardConnectAccount':
          html = "You've earned __COUNT__ for connecting a streaming platform!";
          break;
        case 'UserRewardVerifyGameAccount':
          html = "You've earned __COUNT__ for verifying a game account!";
          break;
        case 'UserRewardLikeTopPlays':
          html = "You've earned __COUNT__ for like top plays!";
          break;
        case 'UserRewardTeamRegisteredForBracket':
          html = "You've earned __COUNT__ for registered bracket!";
          break;
        case 'UserRewardTeamCompletesBracket':
          html = "You've received __COUNT__ for completing bracket!";
          break;
        case 'UserRewardRankTop1':
          html = "You've received __COUNT__ for finishing 1st in __NAME__!";
          break;
        case 'UserRewardRankTop3':
          html = "You've received __COUNT__ for finishing top 3 in __NAME__!";
          break;
        case 'UserRewardRunTournament':
          html = "You've received __COUNT__ for running an event!";
          break;
        case 'UserRewardQuestComplete':
          html = "You've received __COUNT__ for completing __NAME__!";
          break;
        case 'UserRewardWatched15Min':
          html = "You've received __COUNT__ for watching 15 minutes of the Code Red tournament!";
          break;
        case 'GuestFeatureWatched15Min':
          html = "You've received __COUNT__ for watching 15 minutes of the Code Red tournament! Create an account to redeem your rewards!";
          break;
        case 'UserRewardWatched30Min':
          html = "You've received __COUNT__ for watching 30 minutes of the Code Red tournament!";
          break;
        case 'GuestFeatureWatched30Min':
          html = "You've received __COUNT__ for watching 30 minutes of the Code Red tournament! Create an account to redeem your rewards!";
          break;
        case 'UserRewardWatched60Min':
          html = "You've received __COUNT__ for watching 1 hour of the Code Red tournament!";
          break;
        case 'GuestFeatureWatched60Min':
          html = "You've received __COUNT__ for watching 1 hour of the Code Red tournament! Create an account to redeem your rewards!";
          break;
        case 'UserRewardWatched120Min':
          html = "You've received __COUNT__ for watching 2 hours of the Code Red tournament!";
          break;
        case 'GuestFeatureWatched120Min':
          html = "You've received __COUNT__ for watching 2 hours of the Code Red tournament! Create an account to redeem your rewards!";
          break;
        case 'UserRewardWatched60MinAfterFirst120Min':
          html = "You've received __COUNT__ for watching an additional hour of the Code Red tournament!";
          break;
        case 'GuestFeatureWatched60MinAfterFirst120Min':
          html = "You've received __COUNT__ for watching an additional hour of the Code Red tournament! Create an account to redeem your rewards!";
          break;
        default:
          html = "You've earned __COUNT__!";
          break;
      }
      return html;
    },
    getAnimationTitleUserReward(msgNotification) {
      let html;
      switch (msgNotification) {
        case 'UserRewardQuestComplete':
          html = 'Quest completed!';
          break;
        case 'UserRewardWinningEvent':
          html = 'Tournament Win';
          break;
        case 'UserRewardRunTournament':
          html = 'Tournament Completed!';
          break;
        case 'UserRewardRankTop1':
        case 'UserRewardRankTop3':
          html = 'Tournament Placement';
          break;
        default:
          html = 'CROWNS!';
          break;
      }
      return html;
    },
    receiveNotification(msg) {
      const action = msg.split('#');
      if (action[0] === 'NotificationUserFundsAdded') {
        EventBus.$emit(NOTIFICATION_USER_FUNDS_ADDED);
      } else if (action[0] === 'NotificationUserFundsClearPaymentProcessing') {
        EventBus.$emit(NOTIFICATION_USER_FUNDS_CLEAR_PROCESSING_PAYMENT);
        return;
      }
      if (!msg.includes('QualificationSignupAcceptJoinTeam') || action[7]) {
        if (action[0] !== 'UserReward') {
          let typeAward = this.ANIMATION_TYPES.NORMAL;
          let amount = 0;
          if (msg.includes('GuestFeature')) {
            typeAward = parseInt(action[1]);
            amount = parseInt(action[2]);
          } else if (msg.includes('UserReward')) {
            typeAward = parseInt(action[2]);
            amount = parseInt(action[3]);
          }

          this.$store.dispatch('notifications/addNewNotification', msg);

          if (typeAward === this.ANIMATION_TYPES.NORMAL) {
            // https://afkvrgg.atlassian.net/browse/GAME-10405?focusedCommentId=57346
            if (this.$store.state.notifications.notifications_popup.length < 2) {
              this.$store.dispatch('notifications/addNotificationPopup', msg);
            }
          } else {
            this.$store.dispatch('notifications/addNotificationAnimation', {
              type: typeAward,
              amount: amount,
              msg: msg,
            });
          }
        }
      }
    },
  },
};
